import { select, cluster, hierarchy, ClusterLayout, HierarchyNode } from 'd3';
import { DendroCtrParams } from '../types';
import Svg from '../Base/svg';
import Dims from '../Base/dims';
import Margin from '../Base/margin';
import Data from '../Base/data';
import Utils from '../Utils';

export class Dendro {
  private elementId: string;
  private element: Svg;

  private dims: Dims;
  private margin: Margin;

  public data: Data;
  private _inflection = { x: 50, y: 150 };
  private _cluster: ClusterLayout<any>;
  private _root: HierarchyNode<any>;
  private _nodeRadius = 10;

  constructor(params: DendroCtrParams = {}) {
    this.elementId = params.elementId;

    this.dims = new Dims(params.height, params.width);
    this.margin = new Margin(params.margin);

    this.data = new Data(params.data);

    this._inflection = params.inflection ?? { x: 50, y: 150 };
    this._nodeRadius = params.nodeRadius ?? 10;

    this._useAutoLayout();
  }

  public render() {
    const { elementId, margin } = this;
    const { height, width } = this.dims.both();
    this.element = new Svg({ elementId, height, width, margin });
    this.element.draw();

    this._drawLinks();
    this._drawNodes();
  }

  private _drawLinks() {
    const links = this._root.descendants().slice(1);

    const { x: infX, y: infY } = this._inflection;

    const attr = {
      d: function (d: any) {
        const cmds = `M${d.y},${d.x}C${d.parent.y + infX},${d.x} ${d.parent.y + infY},${d.parent.x} ${d.parent.y},${d.parent.x}`;
        return cmds;
      },
      stroke: '#A6CEE3',
    };

    const styles = {
      fill: 'none',
    };

    Utils.drawPath(this.element.d3Svg, links, { attr, styles });
  }

  private _drawNodes() {
    // TODO: Need to create a drawing utility for the nodes
    // but a cut point hasn't quite revealed itself yet..
    const nodes = this._root.descendants();

    const sel = this.element.d3Svg.selectAll('g').data(nodes).enter().append('g');
    sel.attr('transform', function (d: any) {
      return `translate(${d.y},${d.x})`;
    });
    sel.append('circle').attr('r', this._nodeRadius).style('fill', 'steelblue').attr('stroke', '#E3E3E3').style('stroke-width', 2);
  }

  private _useAutoLayout() {
    const { height, width } = this.dims.marDims(this.margin);
    this._cluster = cluster().size([height, width]);
    const data = this.data.consume();
    this._root = hierarchy(data, (d) => d.children);
    this._cluster(this._root);
  }
}
